import axios from 'axios';

const url = process.env.VUE_APP_API_BASE_URL;

function schedule() {
    return axios.get(`${url}/schedule`)
        .then(response => {
            return {
                schedule: response.data,
                meta: response.data.meta
            };
        });
}

function schedulePage(page) {
    let allUrl = `${url}/schedule/` + page;
    return axios.get(allUrl)
        .then(response => {
            return {
                schedulePage: response.data,
                meta: response.data.meta
            };
        });
}

function usersList() {
    return axios.get(`${url}/admin/retouchersList`)
        .then(response => {
            return {
                usersList: response.data,
                meta: response.data.meta
            };
        });
}

function scheduleAdmin(retoucher) {
    const payload = JSON.stringify({retoucher});
    const options = {
        headers: {
            'Content-Type': 'application/json',
        }
    };
    return axios.post(`${url}/schedule_admin`, payload, options)
        .then(response => {
            return response.data;
        });
}

function scheduleAdminPage(params) {
    let retoucher = params.retoucher;
    const payload = JSON.stringify({retoucher});
    const options = {
        headers: {
            'Content-Type': 'application/json',
        }
    };
    let allUrl = `${url}/schedule_admin/` + params.page;
    return axios.post(allUrl, payload, options)
        .then(response => {
            return response.data;
        });
}

function scheduleUpdate(params) {
    const payload = JSON.stringify(params.updateParams);
    const options = {
        headers: {
            'Content-Type': 'application/json',
        }
    };
    let allUrl = url + params.urlToUpdate;
    return axios.post(allUrl, payload, options)
        .then(response => {
            return response.data;
        });
}

function scheduleMaria(params) {
    let allUrl = `${url}/schedule_maria/` + params.status;
    if('page' in params && Number(params.page) > 0 ) allUrl = allUrl +'/' +params.page;
    if('year' in params && Number(params.year) > 0 ) allUrl = allUrl +'/' +params.year;
    return axios.get(allUrl)
        .then(response => {
            return {
                scheduleMaria: response.data,
                meta: response.data.meta
            };
        });
}

function scheduleMariaTime(params) {
    let allUrl = `${url}/schedule_maria/minute-employment/` + params.status;
    if('page' in params && Number(params.page) > 0 ) allUrl = allUrl +'/' +params.page;
    if('year' in params && Number(params.year) > 0 ) allUrl = allUrl +'/' +params.year;
    return axios.get(allUrl)
        .then(response => {
            return {
                scheduleMariaTime: response.data,
                meta: response.data.meta
            };
        });
}

function schedulePageMaria(params) {
    let allUrl = `${url}/schedule_maria/` + params.status + '/' + params.page;
    if(params.year) allUrl = allUrl + `/` + params.year;
    return axios.get(allUrl)
        .then(response => {
            return {
                schedulePageMaria: response.data,
                meta: response.data.meta
            };
        });
}

function schedulePageMariaTime(params) {
    let allUrl = `${url}/schedule_maria/minute-employment/` + params.status + '/' + params.page;
    if(params.year) allUrl = allUrl + `/` + params.year;
    return axios.get(allUrl)
        .then(response => {
            return {
                schedulePageMariaTime: response.data,
                meta: response.data.meta
            };
        });
}

function scheduleAdminMaria(data) {
    const payload = JSON.stringify(data);
    const options = {
        headers: {
            'Content-Type': 'application/json',
        }
    };
    let allUrl = `${url}/schedule_admin_maria/` + data.page + '/' + data.year;

    return axios.post(allUrl, payload, options)
        .then(response => {
            return response.data;
        });
}

function scheduleRetoucherSignUpNow(data) {
    const payload = JSON.stringify({data});
    const options = {
        headers: {
            'Content-Type': 'application/json',
        }
    };
    return axios.post(`${url}/schedule_maria/sign-up/now`, payload, options)
        .then(response => {
            return response.data;
        });
}

function scheduleAdminPageMaria(params) {
    let retoucher = params.retoucher;
    const payload = JSON.stringify({retoucher});
    const options = {
        headers: {
            'Content-Type': 'application/json',
        }
    };

    let allUrl = `${url}/schedule_admin_maria/` + params.page;
    if(params.year) allUrl = allUrl + `/` + params.year
    return axios.post(allUrl, payload, options)
        .then(response => {
            return response.data;
        });
}

function scheduleUpdateMaria(params) {
    const payload = JSON.stringify(params.updateParams);
    const options = {
        headers: {
            'Content-Type': 'application/json',
        }
    };
    let allUrl = url + params.urlToUpdate;
    return axios.post(allUrl, payload, options)
        .then(response => {
            return response.data;
        });
}

function scheduleMariaPro(params) {
    let allUrl = `${url}/schedule_maria_pro/` + params.status;
    if('page' in params && Number(params.page) > 0 ) allUrl = allUrl +'/' +params.page;
    if('year' in params && Number(params.year) > 0 ) allUrl = allUrl +'/' +params.year;
    return axios.get(allUrl)
        .then(response => {
            return {
                scheduleMariaPro: response.data,
                meta: response.data.meta
            };
        });
}

function schedulePageMariaPro(params) {

    let allUrl = `${url}/schedule_maria_pro/` + params.status + '/' + params.page;
    if(params.year) allUrl = allUrl + `/` + params.year;
    return axios.get(allUrl)
        .then(response => {
            return {
                schedulePageMariaPro: response.data,
                meta: response.data.meta
            };
        });
}

function scheduleAdminMariaPro(retoucher) {
    const payload = JSON.stringify({retoucher});
    const options = {
        headers: {
            'Content-Type': 'application/json',
        }
    };
    return axios.post(`${url}/schedule_admin_maria_pro`, payload, options)
        .then(response => {
            return response.data;
        });
}

function scheduleAdminPageMariaPro(params) {
    let retoucher = params.retoucher;
    const payload = JSON.stringify({retoucher});
    const options = {
        headers: {
            'Content-Type': 'application/json',
        }
    };

    let allUrl = `${url}/schedule_admin_maria_pro/` + params.page;
    if(params.year) allUrl = allUrl + `/` + params.year;
    return axios.post(allUrl, payload, options)
        .then(response => {
            return response.data;
        });
}
function scheduleUpdateMariaPro(params) {
    const payload = JSON.stringify(params.updateParams);
    const options = {
        headers: {
            'Content-Type': 'application/json',
        }
    };
    let allUrl = url + params.urlToUpdate;
    return axios.post(allUrl, payload, options)
        .then(response => {
            return response.data;
        });
}

function scheduleMassSubscribeMariaPro(params) {
    const payload = JSON.stringify(params);
    const options = {
        headers: {
            'Content-Type': 'application/json',
        }
    };
    return axios.post(`${url}/schedule_maria_pro/mass_subscribe`, payload, options)
        .then(response => {
            return response.data;
        });
}

function scheduleValidateTime(retoucher) {
    const payload = JSON.stringify({retoucher});
    const options = {
        headers: {
            'Content-Type': 'application/json',
        }
    };
    return axios.post(`${url}/schedule/validate-time`, payload, options)
        .then(response => {
            return response.data;
        });
}

function scheduleMinuteEmploymentPro(params) {
    let requestUrl = `${url}/schedule_maria_pro/minute-employment?`;
    for (const key in params) {
        if (params.hasOwnProperty(key)) {
            requestUrl += `${key}=${params[key]}&`;
        }
    }
    return axios.get(requestUrl)
        .then(response => {
            return response.data;
        });
}

export default {
    schedule,
    schedulePage,
    usersList,
    scheduleAdmin,
    scheduleAdminPage,
    scheduleUpdate,
    scheduleMaria,
    scheduleMariaTime,
    schedulePageMaria,
    schedulePageMariaTime,
    scheduleAdminMaria,
    scheduleAdminPageMaria,
    scheduleUpdateMaria,
    scheduleMariaPro,
    schedulePageMariaPro,
    scheduleAdminMariaPro,
    scheduleAdminPageMariaPro,
    scheduleUpdateMariaPro,
    scheduleValidateTime,
    scheduleRetoucherSignUpNow,
    scheduleMassSubscribeMariaPro,
    scheduleMinuteEmploymentPro
};
